module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 101.38912f54.png";